import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { api, errMsg, flag } from "../lib/api";

export const ComingSoon = ({ country }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/notify", { email, country: country.code });
      setDone(true);
      toast.success(`We'll email you when HostAfricair launches in ${country.name}`);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div data-testid="coming-soon-panel" className="rounded-3xl border-2 border-dashed border-primary/40 bg-accent p-8">
      <div className="flex items-center gap-3">
        <img src={flag(country.code)} alt="" className="h-5 w-7 rounded-sm object-cover" />
        <span className="text-xs font-semibold uppercase tracking-widest text-primary">Coming soon</span>
      </div>
      <h3 className="mt-3 text-2xl font-bold">We're signing local networks in {country.name}</h3>
      <p className="mt-2 max-w-xl text-sm text-muted-foreground">
        Prices will be in {country.currency}. Leave your email and we'll tell you the moment packages go live. Domains are already available.
      </p>
      {done ? (
        <p className="mt-5 flex items-center gap-2 text-sm font-semibold text-secondary" data-testid="notify-success"><BellRing className="h-4 w-4" /> You're on the list.</p>
      ) : (
        <form onSubmit={submit} className="mt-5 flex max-w-md gap-2">
          <Input type="email" required placeholder="you@email.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="notify-email-input" className="bg-white" />
          <Button type="submit" data-testid="notify-submit-btn">Get notified</Button>
        </form>
      )}
    </div>
  );
};
